import { Injectable, Type } from '@angular/core';
import { BaseApiService } from '@kinet-open-network/client/core/api-client';
import { Tag } from '../models/tag.model';

@Injectable({
  providedIn: 'root',
})
export class TagsService extends BaseApiService<Tag> {
  override model: Type<Tag> = Tag;

  override get endpoint(): string {
    return '/tags';
  }
}
